import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom'
import MyQrCode from './MyQrCode'
import dateFormat from 'dateformat'
import CryptoJS from "crypto-js";

const settings = {
    sac: false,
    decimals: 2,
    thousands_sep: ',',
    decimals_sep: '.'
};



function formatDecimal(number, decimals = null, settings) {
    if (isNaN(number)) {
        return null;
    }

    if (decimals === null || decimals === undefined) {
        decimals = settings.decimals;
    }

    return Number(number).toFixed(decimals);
}

function formatSAC(numberStr) {
    // Simple SAC formatter: Indian-style grouping (e.g., 12,34,567.89)
    const [intPart, decPart] = numberStr.split('.');
    const lastThree = intPart.slice(-3);
    const otherNumbers = intPart.slice(0, -3);
    const formattedInt = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + (otherNumbers ? ',' : '') + lastThree;
    return decPart ? `${formattedInt}.${decPart}` : formattedInt;
}

function formatNumber(number, decimals = null, settings = {
    sac: false,
    decimals: 2,
    thousands_sep: ',',
    decimals_sep: '.'
}) {
    if (isNaN(number)) {
        return null;
    }

    const ts = settings.thousands_sep === '0' ? ' ' : settings.thousands_sep;
    const ds = settings.decimals_sep;
    const fixed = formatDecimal(number, decimals, settings);

    if (settings.sac) {
        return formatSAC(fixed);
    }

    const parts = fixed.split('.');
    const intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
    const decimalPart = parts[1] || '';

    return decimalPart ? `${intPart}${ds}${decimalPart}` : intPart;
}

function formatMoney(number, currency = '', settings = {
    sac: false,
    decimals: 2,
    thousands_sep: ',',
    decimals_sep: '.'
}) {
    console.log('number', number)
    if (isNaN(number)) return null;

    const decimals = settings.decimals;
    const ts = settings.thousands_sep === '0' ? ' ' : settings.thousands_sep;
    const ds = settings.decimals_sep;

    const formattedDecimal = formatDecimal(number, decimals, settings);

    if (settings.sac) {
        return currency + formatSAC(formattedDecimal);
    }

    const [intPart, decPart] = formattedDecimal.split('.');
    const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ts);
    return currency + formattedInt + (decPart ? ds + decPart : '');
}
function hrld(cell) {
    return dateFormat(cell, "dd/mm/yyyy, h:MM TT");

}
function hrsd(cell) {
    return dateFormat(cell, "dd/mm/yyyy");

}
function Sale() {
    const [saleDetail, setSaleDetail] = useState();
    const [apiDetail, setAPIDetail] = useState();
    const { id } = useParams()

    const decode_html = (cell) => {
        return cell
    }
    useEffect(() => {
        axios.post('https://indoc.co.in/api/sales', { uuid: id })
            .then(response => {
                setSaleDetail(response.data.selectedSale)
            })
            .catch(error => {
                setAPIDetail(1)
                console.error('Error fetching users:', error)
            }
            );
    }, []);

    function handlePrint() {
        window.print()
        //the window.print() command is what is telling the browser to print the page
    }
    const base_url = ''
    const file_name = ''
    const default_notes = `<p style={{ textAlign: "justify" }}><span>1. We declare the invoice shows the actual price of goods described & that all particulars are true and correct.</span><br /><span>2. Goods once sold cannot be taken back or exchanged.</span><br /><span>3. No Warranty on burnt, Water log or physically damage.</span><br /><span>4. For claim on warranty goods customer needs visit authorised service centres only & original invoice must be produced. Warranty as per the manufacturer policy.</span><br /><span>5. All disputes subject to Bangalore Jurisdiction only.</span></p>`;
    const setting_notes = saleDetail?.Settings?.sales_notes !== "" && saleDetail?.Settings?.sales_notes !== null && saleDetail?.Settings?.sales_notes !== undefined ? saleDetail?.Settings?.sales_notes : null
    const notes = saleDetail?.ledger?.notes !== null ? saleDetail?.ledger?.notes : setting_notes ? setting_notes : default_notes
    return saleDetail !== null && saleDetail !== undefined ? (
        <>
            <meta charSet="utf-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            <title>Sale {saleDetail?.reference_no} </title>
            <link
                href="https://indocbooks.indocweb.in/themes/default/assets/styles/style.css"
                rel="stylesheet"
            />
            <link
                href="https://indocbooks.indocweb.in/assets/bs/bootstrap.min.css"
                rel="stylesheet"
            />
            <style
                type="text/css"
                dangerouslySetInnerHTML={{
                    __html:
                        "\n    html,\n    body {\n        background: #FFF;\n        overflow-x: hidden;\n    }\n\n    body:before,\n    body:after {\n        display: none !important;\n    }\n\n    .table th {\n        text-align: center;\n        padding: 5px;\n    }\n\n    .table td {\n        padding: 4px;\n        font-size: 12px;\n        vertical-align: top;\n    }\n\n    p {\n        font-size: 12px;\n    }\n\n    .nested-table {\n        border-bottom: 1px solid #000;\n    }\n\n    #content {\n        background: white;\n    }\n\n    .text-uppercase {\n        text-transform: uppercase;\n    }\n\n    .pheader {\n        border-bottom: 1px solid #000;\n        padding: 5px;\n        width: 100%;\n        line-height: 40px;\n        max-height: 40px;\n        min-height: 40px;\n    }\n\n    .footer > p {\n        line-height: 1.2;\n    }\n\n    .sale-page {\n        padding: 16px 12px 32px;\n    }\n\n    .sale-logo {\n        max-width: 100%;\n        height: auto;\n        float: none !important;\n        display: block;\n    }\n\n    .sale-table {\n        width: 100%;\n        margin-bottom: 16px;\n    }\n\n    .sale-meta-table {\n        width: 100%;\n        margin-bottom: 8px;\n        table-layout: fixed;\n    }\n\n    .sale-meta-table td,\n    .sale-meta-table th,\n    .sale-address-cell,\n    .sale-detail-cell {\n        word-break: break-word;\n        overflow-wrap: anywhere;\n        white-space: normal;\n        hyphens: auto;\n    }\n\n    .sale-address-cell {\n        max-width: 0;\n    }\n\n    .sale-items-wrap {\n        width: 100%;\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch;\n    }\n\n    .sale-payment-info {\n        display: block;\n        word-break: break-word;\n    }\n\n    .sale-signoff {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        gap: 16px;\n        width: 100%;\n    }\n\n    .sale-signoff span {\n        display: inline-block;\n    }\n\n    @media (max-width: 767px) {\n        .sale-page {\n            padding: 12px 8px 24px;\n        }\n\n        .sale-page .row {\n            margin-left: 0;\n            margin-right: 0;\n        }\n\n        .sale-page [class*='col-'] {\n            float: none;\n            width: 100%;\n            padding-left: 0;\n            padding-right: 0;\n            margin-left: 0;\n        }\n\n        .sale-items-table {\n            min-width: 640px;\n        }\n\n        .table th,\n        .table td,\n        p {\n            font-size: 11px;\n        }\n\n        h2 {\n            font-size: 22px;\n            margin-top: 8px;\n        }\n\n        h4 {\n            font-size: 16px;\n        }\n\n        .sale-title-cell,\n        .sale-header-cell,\n        .sale-detail-cell {\n            display: block;\n            width: 100%;\n        }\n\n        .sale-detail-cell {\n            padding-top: 12px;\n        }\n\n        .sale-signoff {\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n        }\n\n        .sale-signoff span {\n            display: inline-block;\n            float: none !important;\n            margin-bottom: 0;\n        }\n\n        .no-print .btn {\n            width: 100%;\n            white-space: normal;\n        }\n    }\n\n    @media print {\n        .no-print {\n            display: none;\n        }\n    }"
                }}
            />
            <div id="wrap" className="sale-page">
                <div className="row">
                    <div className="col-lg-offset-1 col-lg-10">
                        <div className="table-responsive wrapper">
                            <table className="table table-bordered table-hover table-striped sale-table sale-meta-table">
                                <thead className="tableheader">
                                    <tr>
                                        <td colSpan={3} style={{ textAlign: "center" }} className="sale-header-cell">
                                            {saleDetail?.logo ? (<img className="sale-logo" src={saleDetail?.logo} alt={saleDetail?.biller?.company !== '-' ? saleDetail?.biller?.company : saleDetail?.biller?.name} />) : (<h4>{saleDetail?.biller?.company !== '-' ? saleDetail?.biller?.company : saleDetail?.biller?.name}</h4>)}
                                        </td>

                                        <td style={{ textAlign: "center" }} className="sale-title-cell">
                                            <h2>{saleDetail?.inv_name?.name}</h2>
                                            <p>{saleDetail?.copy_name + " Copy"}</p>

                                        </td>
                                    </tr>
                                    {saleDetail?.Settings?.einvoice_req === "1" && saleDetail?.Settings?.einvoice_indoc === "1" ?
                                        saleDetail?.einvoices ? (<tr>
                                            <td style={{ fontWeight: "bold" }}>AckNo: {saleDetail?.einvoices[0]?.AckNo}
                                            </td>
                                            <td style={{ fontWeight: "bold" }}>Ack Date: {hrld(saleDetail?.einvoices[0]?.AckDt)}
                                            </td>
                                            <td style={{ fontWeight: "bold" }}>Irn: {saleDetail?.einvoices[0]?.Irn}
                                            </td>
                                        </tr>) : "" : ""}

                                    <tr>
                                        <td colSpan={3} className="sale-header-cell" style={{textWrap: "auto"}}>
                                            <h4 className="">{saleDetail?.biller?.unit_of !== '' ? "A unit of " + saleDetail?.biller?.unit_of : saleDetail?.biller?.company}</h4>
                                            {/*  */}
                                            {saleDetail?.biller?.address + " " + saleDetail?.biller?.address2} <br /> {saleDetail?.biller?.city + " " + saleDetail?.biller?.postal_code + " " + saleDetail?.biller?.state + " " + saleDetail?.biller?.country}
                                            <br />
                                            Tel: {saleDetail?.biller?.phone ? saleDetail?.biller?.phone : ''}
                                            <br />
                                            Email: {saleDetail?.biller?.email ? saleDetail?.biller?.email : ''}
                                            <br />
                                            {(saleDetail?.biller?.vat_no !== "-" && saleDetail?.biller?.vat_no !== "") ? " GSTIN: " + saleDetail?.biller?.vat_no : ""}
                                            {(saleDetail?.biller?.cf3 !== "-" && saleDetail?.biller?.cf3 !== "") ? `<img src="${base_url()}${file_name}"
                                            alt="${saleDetail?.biller?.cf3}" className="pull-right"/>` : ''}
                                            <br />
                                            <hr />
                                            <h4 className="">{saleDetail?.customer?.company ? saleDetail?.customer?.company : saleDetail?.customer?.name} </h4>
                                            {/* Attn: VIMAL */}
                                            <br /> {saleDetail?.customer?.address + " " + saleDetail?.customer?.address2}<br />
                                            {saleDetail?.customer?.city + " " + saleDetail?.customer?.postal_code + " " + saleDetail?.customer?.state + " " + saleDetail?.customer?.country}
                                            <br />
                                            Tel: {saleDetail?.customer?.phone ? saleDetail?.customer?.phone : ''}
                                            <br />
                                            Email: {saleDetail?.customer?.email ? saleDetail?.customer?.email : ''}
                                            <br />
                                            {(saleDetail?.customer?.vat_no !== "-" && saleDetail?.customer?.vat_no !== "") ? " GSTIN: " + saleDetail?.customer?.vat_no : ''}
                                            <p />{" "}
                                        </td>
                                        <td className="sale-detail-cell">
                                            <table className="table table-bordered table-hover table-striped sale-meta-table">
                                                <thead>
                                                    <tr>
                                                        <td></td>

                                                        <td></td>
                                                    </tr>
                                                    {saleDetail?.Settings?.einvoice_req === "1" && saleDetail?.Settings?.einvoice_indoc === "1" ?
                                                        saleDetail?.einvoices ? (<tr>
                                                            <td colSpan="2" style={{ fontWeight: "bold", textAlign: "center" }}>
                                                                <span>E-Invoice</span><br />
                                                                <MyQrCode value={saleDetail?.einvoices[0]?.SignedQRCode} />

                                                            </td>
                                                        </tr>) : "" : ""}
                                                    <tr>
                                                        <td>DATE</td>
                                                        <td>
                                                            {hrld(saleDetail?.date)}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>INVOICE</td>
                                                        <td>{saleDetail?.reference_no}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>SALES STATUS</td>
                                                        <td>{saleDetail?.sale_status}</td>
                                                    </tr>
                                                    {saleDetail?.payments ?
                                                        <tr>
                                                            <td>PAYMENT MODE</td>
                                                            <td>
                                                                {saleDetail?.payments?.map((payment, index) => (

                                                                    <><span>{payment?.paid_by}</span> {saleDetail?.Settings?.payment_detail_in_sale_invoice === "1" ? `(${formatMoney(payment?.amount)})` : ''}, <br /> </>
                                                                ))}
                                                            </td>
                                                        </tr> : ""}

                                                    {saleDetail?.finance_payments ?

                                                        <><tr>
                                                            <td>FINANCE BY</td>
                                                            <td>
                                                                {saleDetail?.finance_payments?.map((finance_payment, index) => (
                                                                    <><span>{finance_payment?.paid_by}</span>,</>
                                                                ))}
                                                            </td>

                                                        </tr>
                                                            <tr>
                                                                <td>FINANCE CODE</td>
                                                                <td>
                                                                    {saleDetail?.finance_payments?.map((finance_payment, index) => (
                                                                        <><span>{finance_payment?.finance_code}</span>,</>
                                                                    ))}

                                                                </td>

                                                            </tr></> : ""}

                                                    <tr>
                                                        <td>PAYMENT STATUS</td>
                                                        <td>{saleDetail?.payment_status}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>PO REF</td>
                                                        <td>{saleDetail?.po_ref}</td>
                                                    </tr>

                                                    {saleDetail?.eway_reference_no && <tr>
                                                        <td>E-WAY BILL NO</td>
                                                        <td>{saleDetail?.eway_reference_no}</td>
                                                    </tr>}
                                                    {saleDetail?.eway_vehicle_no && <tr>
                                                        <td>E-WAY VEHICLE NO</td>
                                                        <td>{saleDetail?.eway_vehicle_no}</td>
                                                    </tr>}
                                                </thead>
                                            </table>
                                            <span className="iterms sale-payment-info">
                                                <p>PAYMENT INFO</p>
                                                {saleDetail?.payments?.map((payment, index) => (
                                                    payment?.note ? decode_html(payment?.note) : ""))}
                                            </span>
                                        </td>
                                    </tr>
                                </thead>
                            </table>
                            <div className="sale-items-wrap">
                            <table className="table table-bordered table-hover table-striped sale-table sale-items-table">
                                <thead>
                                    <tr>
                                        <th className="text-uppercase">Sl No</th>
                                        <th colSpan={2} className="text-uppercase">
                                            Description (Code)
                                        </th>
                                        <th className="text-uppercase">HSN/SAC</th>
                                        <th className="text-uppercase">Qty/Per</th>
                                        {saleDetail?.Settings?.mrp_in_invoice === "1" ? <td className="text-uppercase">MRP</td> : ""}
                                        {saleDetail?.invoice_type_tax !== "1" ?
                                            <th colSpan="3" className="text-uppercase">SubTotal</th> :
                                            <>
                                                <th className="text-uppercase">Rate</th>
                                                {saleDetail?.Settings?.tax1 === "1" ? <th className="text-uppercase">Tax</th> : ""}
                                                {saleDetail?.Settings?.cess_tax === "1" ? <th className="text-uppercase">Cess</th> : ""}
                                                <th className="text-uppercase">SubTotal</th>
                                            </>
                                        }
                                    </tr>
                                </thead>
                                <tbody>
                                    {saleDetail?.items?.map((item, index) => (
                                        <tr key={index}>
                                            <td style={{ textAlign: "center", width: 40 }}>{index + 1}</td>
                                            <td colSpan={2}>
                                                {item?.product_name + " " + (item?.variant ? ' (' + item?.variant + ')' : '')}
                                                {item?.details && (
                                                    <>
                                                        <br />
                                                        {item.details}
                                                    </>
                                                )}
                                                {item?.description && (
                                                    <>
                                                        <br />
                                                        <span dangerouslySetInnerHTML={{ __html: decode_html(item.description) }} />
                                                    </>
                                                )}

                                                {item?.product_serial_nos &&
                                                    item.product_serial_nos.map((serial, indexSerial) => {
                                                        if (
                                                            item.product_id === serial?.product_id &&
                                                            item.sale_item_id === serial?.sale_item_id
                                                        ) {
                                                            return (
                                                                <React.Fragment key={indexSerial}>
                                                                    <br />
                                                                    IMEI: {serial?.serial_no}
                                                                </React.Fragment>
                                                            );
                                                        }
                                                        return null;
                                                    })}
                                            </td>
                                            <td>{item?.hsn_sac}</td>
                                            <td style={{ width: 80, textAlign: "center" }}>{formatNumber(item?.quantity) + ' ' + item?.per_type_name} </td>
                                            {saleDetail?.Settings?.mrp_in_invoice === "1" ? <td style={{ textAlign: "right", width: 90 }}>{formatMoney(item?.mrp)}</td> : ""}
                                            {saleDetail?.invoice_type_tax !== "1" ? <td colSpan={3} style={{ textAlign: "right" }}>{formatMoney(item?.subtotal)}</td> :
                                                <>
                                                    <td style={{ textAlign: "right", width: 90 }}>{formatMoney(item?.net_unit_price)}</td>
                                                    {saleDetail?.Settings?.tax1 === "1" && (
                                                        <td style={{ textAlign: "right", width: 90 }}>
                                                            {item?.item_tax !== 0 && item?.tax_code && (
                                                                <small>({parseFloat(item?.tax_rate)}%)</small>
                                                            )}{" "}
                                                            {formatMoney(item?.item_tax)}
                                                        </td>
                                                    )}
                                                    {saleDetail?.Settings?.cess_tax === "1" && (
                                                        <td style={{ textAlign: "right", width: 90 }}>
                                                            {item?.item_cess_tax !== 0 && item?.cess_tax_code && (
                                                                <small>({parseFloat(item?.cess_tax_rate)}%)</small>
                                                            )}{" "}
                                                            {formatMoney(item?.item_cess_tax)}
                                                        </td>
                                                    )}
                                                    <td style={{ textAlign: "right", width: 110 }}>{formatMoney(item?.subtotal)}</td>
                                                </>}
                                        </tr>

                                    ))}

                                </tbody>
                                <tfoot>
                                    {saleDetail?.shipping !== 0 ?
                                        <tr>
                                            {saleDetail?.shipping !== 0 ? (
                                                saleDetail?.Settings?.mrp_in_invoice === "1" ? (
                                                    <>
                                                        <td colSpan="8" style={{ textAlign: "right", fontWeight: 700 }}>
                                                            Shipping
                                                        </td>
                                                        {saleDetail?.Settings?.cess_tax === "1" ?
                                                            <td colSpan="1" style={{ textAlign: "right" }} className="bold">
                                                            </td> : ""}

                                                        <td style={{ textAlign: "right" }}>
                                                            {formatMoney(saleDetail?.shipping)}
                                                        </td>
                                                    </>
                                                ) : (
                                                    <>
                                                        <td colSpan="7" style={{ textAlign: "right", fontWeight: 700 }}>
                                                            Shipping
                                                        </td>
                                                        {saleDetail?.Settings?.cess_tax === "1" ?
                                                            <td colSpan="1" style={{ textAlign: "right" }} className="bold">
                                                            </td> : ""}
                                                        <td style={{ textAlign: "right" }}>
                                                            {formatMoney(saleDetail?.shipping)}
                                                        </td>
                                                    </>
                                                )) : (
                                                saleDetail?.Settings?.mrp_in_invoice === "1" ? (
                                                    <>
                                                        <td colSpan="5" style={{ textAlign: "right", fontWeight: 700 }}>
                                                            Shipping
                                                        </td>
                                                        <td colSpan="3" style={{ textAlign: "right", fontWeight: 700 }}>

                                                        </td>
                                                        {saleDetail?.Settings?.cess_tax === "1" ?
                                                            <td colSpan="1" style={{ textAlign: "right" }} className="bold">
                                                            </td> : ""}
                                                        <td style={{ textAlign: "right", fontWeight: 700 }}>
                                                            {formatMoney(saleDetail?.shipping)}
                                                        </td>
                                                    </>
                                                ) : (
                                                    <>
                                                        <td colSpan="5" style={{ textAlign: "right", fontWeight: 700 }}>
                                                            Shipping
                                                        </td>
                                                        <td colSpan="2" style={{ textAlign: "right", fontWeight: 700 }}>

                                                        </td>
                                                        {saleDetail?.Settings?.cess_tax === "1" ?

                                                            <td colSpan="1" style={{ textAlign: "right" }} className="bold">
                                                            </td> : ""}
                                                        <td style={{ textAlign: "right", fontWeight: 700 }}>
                                                            {formatMoney(saleDetail?.shipping)}
                                                        </td>
                                                    </>
                                                )
                                            )
                                            }


                                        </tr> : ""}

                                    {saleDetail?.roundoff !== 0 ?
                                        <tr>
                                            {saleDetail?.invoice_type_tax !== "1" ?
                                                saleDetail?.Settings?.mrp_in_invoice === "1" ? (
                                                    <>
                                                        <td colSpan="8" style={{ textAlign: "right", fontWeight: 700 }}>
                                                            Roundoff
                                                        </td>
                                                        <td style={{ textAlign: "right" }}>
                                                            {formatMoney(saleDetail?.roundoff)}
                                                        </td>
                                                    </>) : (
                                                    <>

                                                        <td colSpan="7" style={{ textAlign: "right", fontWeight: 700 }}>
                                                            Roundoff
                                                        </td>
                                                        <td style={{ textAlign: "right" }}>
                                                            {formatMoney(saleDetail?.roundoff)}
                                                        </td>
                                                    </>) :

                                                saleDetail?.Settings?.mrp_in_invoice === "1" ? (
                                                    <>
                                                        <td colSpan="5" style={{ textAlign: "right", fontWeight: 700 }}>
                                                            Roundoff
                                                        </td>
                                                        <td colSpan="3" style={{ textAlign: "right", fontWeight: 700 }}>

                                                        </td>
                                                        {saleDetail?.Settings?.cess_tax === "1" ?
                                                            <td colSpan="1" style={{ textAlign: "right" }} className="bold">
                                                            </td> : ""}
                                                        <td style={{ textAlign: "right", fontWeight: 700 }}>
                                                            {formatMoney(saleDetail?.roundoff)}
                                                        </td>
                                                    </>
                                                ) : (
                                                    <>
                                                        <td colSpan="5" style={{ textAlign: "right", fontWeight: 700 }}>
                                                            Roundoff
                                                        </td>
                                                        <td colSpan="2" style={{ textAlign: "right", fontWeight: 700 }}>

                                                        </td>
                                                        {saleDetail?.Settings?.cess_tax === "1" ?
                                                            <td colSpan="1" style={{ textAlign: "right" }} className="bold">
                                                            </td> : ""}
                                                        <td style={{ textAlign: "right", fontWeight: 700 }}>
                                                            {formatMoney(saleDetail?.roundoff)}
                                                        </td>
                                                    </>
                                                )
                                            }
                                        </tr> : ""}


                                    <tr>
                                        {saleDetail?.invoice_type_tax !== "1" ? (
                                            saleDetail?.Settings?.mrp_in_invoice === "1" ? (
                                                <>
                                                    <td colSpan="8" style={{ textAlign: "right", fontWeight: 700 }}>
                                                        Total
                                                    </td>
                                                    <td style={{ textAlign: "right" }}>
                                                        {formatMoney(
                                                            parseFloat(saleDetail?.total || 0) +
                                                            parseFloat(saleDetail?.product_tax || 0) +
                                                            parseFloat(saleDetail?.product_cess_tax || 0) +
                                                            parseFloat(saleDetail?.roundoff || 0) +
                                                            parseFloat(saleDetail?.shipping || 0)
                                                        )

                                                        }
                                                    </td>
                                                </>) : (
                                                <>
                                                    <td colSpan="7" style={{ textAlign: "right", fontWeight: 700 }}>
                                                        Total
                                                    </td>
                                                    <td style={{ textAlign: "right" }}>
                                                        {formatMoney(
                                                            parseFloat(saleDetail?.total || 0) +
                                                            parseFloat(saleDetail?.product_tax || 0) +
                                                            parseFloat(saleDetail?.product_cess_tax || 0) +
                                                            parseFloat(saleDetail?.roundoff || 0) +
                                                            parseFloat(saleDetail?.shipping || 0)
                                                        )

                                                        }
                                                    </td>
                                                </>)) : (
                                            saleDetail?.Settings?.mrp_in_invoice === "1" ? (
                                                <>
                                                    <td colSpan="5" style={{ textAlign: "right", fontWeight: 700 }}>
                                                        Total
                                                    </td>
                                                    <td colSpan="3" style={{ textAlign: "right", fontWeight: 700 }}>

                                                        {formatMoney(saleDetail?.product_tax)}
                                                    </td>
                                                    {saleDetail?.Settings?.cess_tax === "1" ?
                                                        <td colSpan="1" style={{ textAlign: "right" }} className="bold"><b>
                                                            {formatMoney(saleDetail?.product_cess_tax)}</b>
                                                        </td> : ""}

                                                    <td style={{ textAlign: "right", fontWeight: 700 }}>
                                                        {formatMoney(
                                                            parseFloat(saleDetail?.total || 0) +
                                                            parseFloat(saleDetail?.product_tax || 0) +
                                                            parseFloat(saleDetail?.product_cess_tax || 0) +
                                                            parseFloat(saleDetail?.roundoff || 0) +
                                                            parseFloat(saleDetail?.shipping || 0)
                                                        )

                                                        }
                                                    </td>
                                                </>) : (
                                                <>

                                                    <td colSpan="5" style={{ textAlign: "right", fontWeight: 700 }}>
                                                        Total
                                                    </td>
                                                    <td colSpan="2" style={{ textAlign: "right", fontWeight: 700 }}>

                                                        {formatMoney(saleDetail?.product_tax)}
                                                    </td>
                                                    {saleDetail?.Settings?.cess_tax === "1" ?
                                                        <td colSpan="1" style={{ textAlign: "right" }} className="bold">
                                                            {formatMoney(saleDetail?.product_cess_tax)}
                                                        </td> : ""}
                                                    <td style={{ textAlign: "right", fontWeight: 700 }}>
                                                        {formatMoney(
                                                            parseFloat(saleDetail?.total || 0) +
                                                            parseFloat(saleDetail?.product_tax || 0) +
                                                            parseFloat(saleDetail?.product_cess_tax || 0) +
                                                            parseFloat(saleDetail?.roundoff || 0) +
                                                            parseFloat(saleDetail?.shipping || 0)
                                                        )

                                                        }
                                                    </td>
                                                </>)

                                        )}
                                    </tr>






                                </tfoot>

                            </table>
                            </div>
                            {saleDetail?.coupons !== null && saleDetail?.coupons !== undefined ? (
                                 <>
                            <p className="footer" style={{ textAlign: "justify" }}>
                                <strong>Coupon: </strong>
                            </p>
                            <table className="table table-bordered table-hover table-striped sale-table">
                                <thead>
                                    <tr>
                                        <th colSpan={2} className="text-uppercase">Card No</th>
                                        <th className="text-uppercase">
                                            Value
                                        </th>
                                        <th className="text-uppercase">Used For</th>
                                        <th className="text-uppercase">Expiry</th>
                                    </tr>
                                </thead>
                                <tbody>
                                        <tr>
                                            <td colSpan={2}>
                                                {saleDetail?.coupons?.card_no}
                                                
                                            </td>
                                            <td>{formatMoney(saleDetail?.coupons?.value)}</td>
                                            <td>{(saleDetail?.coupons?.redeem_category)} of {saleDetail?.coupons?.redeem_value} {saleDetail?.coupons?.redeem_value_type === 1 || saleDetail?.coupons?.redeem_value_type === '1' ? '%' : 'Rs'}</td>
                                            <td>{hrsd(saleDetail?.coupons?.expiry)}</td>
                                            
                                        </tr>

                                </tbody>
                                </table>
                            </>) : ""}
                            {/* <h5 className="bold">Tax Summary</h5>
                            <table className="table table-bordered table-condensed">
                                <thead>
                                    <tr>
                                        <td>Name</td>
                                        <td>SGST</td>
                                        <td>CGST</td>
                                        <td>Qty/Weight</td>
                                        <td>Tax Excl Amt</td>
                                        <td>Tax Amt</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>GST 18%</td>
                                        <td className="text-center">(9%)610.17</td>
                                        <td className="text-center">(9%)610.17</td>
                                        <td className="text-center">1</td>
                                        <td className="text-right">6,779.66</td>
                                        <td className="text-right">1,220.34</td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colSpan={5} className="text-right">
                                            <b>Total Tax Amount</b>
                                        </td>
                                        <td className="text-right">
                                            <b>1,220.34</b>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table> */}
                            <p className="footer" style={{ textAlign: "justify" }}>
                                <strong>Sales Notes: </strong>
                            </p>
                            <span className="footer" style={{ textAlign: "justify" }} dangerouslySetInnerHTML={{
                                __html: decode_html(notes)
                            }} >

                            </span>

                            <p className="text-center">Thank you for your valuable business.</p>
                            <p className="sale-signoff">
                                <span className="text-left">Customer: {saleDetail?.customer?.name}</span>
                                <span style={{ float: "right" }}>For {saleDetail?.biller?.company}</span>
                            </p>
                            <br /><br />
                            <p className="sale-signoff">
                                <span className="text-left">Signature</span>
                                <span style={{ float: "right" }}>Signature</span>
                            </p>

                        </div>
                        <div className="text-center no-print">
                        {saleDetail?.payments?.map((payment, index) => (
                            payment?.kyc_required == 1 ? payment?.kyc != 1 ? (/phonorange_/.test(saleDetail?.sUUID)) ? (
                            <><a href={"https://phonorange.indocweb.in/kyc/"+saleDetail?.sUUID8+'#Intent;scheme=https;package=com.android.chrome;end'} className="btn btn-warning text-right no-print" target="_blank">Verify {payment?.paid_by} KYC</a> <br /> </>
                            ) : (<><a href={"https://indocbooks.indocweb.in/kyc/"+saleDetail?.sUUID8+'#Intent;scheme=https;package=com.android.chrome;end'} className="btn btn-warning text-right no-print" target="_blank">Verify {payment?.paid_by} KYC</a> <br /> </>
                            ) : <span>{payment?.paid_by} - KYC Verified</span> : ''
                        ))}
                        <br />
                        </div>
                        <div className="text-center no-print">
                            <button onClick={() => window.print()} href="#" className="btn btn-success text-right no-print" target="_blank" >
                                Print / Save As PDF
                            </button>
                        </div>
                        
                    </div>
                </div>
            </div >

        </>

    ) : apiDetail ? "INVAILD SALE LINK" : "loading..."
}

export default Sale;
